import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {Open} from "../../../../../../models/questions/Open";
import {AbstractControl} from "@angular/forms";
import {OpenStatementErrorMatcher} from "../../../../../../error-matchers/OpenStatementErrorMatcher";
import {SurveyViewerService} from "../../../services/survey-viewer.service";
import {IQuestionComponent} from "../../../../../../interfaces/IQuestionComponent";

@Component({
  selector: 'app-honey-pot',
  templateUrl: './honey-pot.component.html',
  styleUrls: ['./honey-pot.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HoneyPotComponent implements IQuestionComponent, OnInit {

  @Input() question: Open
  @Input() isSmallScreen: boolean
  @Input() activeLang: string

  questionFormControl: AbstractControl
  errorMatcher: OpenStatementErrorMatcher

  constructor(public surveyViewerService: SurveyViewerService) {
  }

  ngOnInit(): void {
    this.errorMatcher = new OpenStatementErrorMatcher(this.question.isOptional)
    this.questionFormControl
      = this.surveyViewerService.activeSurvey$.value.form
      .get(this.question.key)
      .get(this.question.rowKeys.pop())
      .get(this.question.commentsControlName)
      .get(this.question.statementKeys.pop())

    // this.changeFormUpdateStrategy(this.questionFormControl, 'blur');

  }

}
